export default {
  farmerName: "Nombre del granjero",
  deleteFarmH: "¿Estás seguro de que deseas eliminar esta granja?",
  maxLimit:"El límite máximo no debe ser mayor que seis dígitos.",
  emptyDeforestationStatus: "El estado de deforestación del EUDR está vacío.",
  confirmation: "Confirmación",
  deleteFarmMsg:
    "Por favor, proporciona confirmación adicional, ya que eliminar esta granja eliminará toda la información relacionada con la granja, como cultivos, informes, etc.",
  psw: "Contraseña",
  "Avg Area in Hectares": "Promedio de Área en Hectáre",
  "Avg Area in Acres": "Promedio de Área en Cuerd",
  "Avg Area in Manzana": "Promedio de Área en Manzana",
  used: "Usado",
  january: "Enero",
  february: "Febrero",
  march: "Marzo",
  april: "Abril",
  may: "Mayo",
  june: "Junio",
  july: "Julio",
  august: "Agosto",
  september: "Septiembre",
  october: "Octubre",
  november: "Noviembre",
  december: "Diciembre",
  topFive: "Top 5",
  confPsw: "Confirmar contraseña",
  newPsw: "Nueva contraseña",
  email: "Correo electrónico",
  emailId: "ID del correo electrónico",
  submit: "Enviar",
  cancel: "Cancelar",
  dashboard: "Panel",
  mainDashboard: "Tablero Principal",
  userDashboard: "Tablero de Usuario",
  faqs: "FAQ",
  id: "ID",
  reset: "Reiniciar",
  processor: "Procesador",
  cuppingScore: "Puntuación de Cata",
  label: "Etiqueta",
  expiry: "Caducidad",
  users: "Usuarios",
  appUser: "usuario de la aplicación",
  app_users: "Usuarios de la aplicación",
  dimitraAdmin: "Dimitra Admin",
  offline_users: "Usuarios sin conexión",
  admin_users: "Usuarios Admin",
  search: "búsqueda",
  searchByProducerName: "Buscar por nombre del productor",
  searchBy: "búsqueda {type}",
  firstName: "Primero nombre",
  lastName: "Apellido",
  mobile: "Móvil",
  mobileNumber: "Número de móvil",
  department: "Departamento",
  role: "Función",
  status: "Estado",
  permission: "Permisos",
  activity_log: "Registros de actividad",
  profile_auth: "Autenticación del perfil",
  countryCode: "Código del país",
  selectDept: "Seleccionar departamento",
  selectRole: "Seleccionar función",
  edit: "Editar",
  update: "Actualizar",
  delete: "Borrar",
  view: "Ver",
  deactivate: "Desactivado",
  activate: "Activar",
  serverError: "Algo salió mal. Inténtalo de nuevo más tarde.",
  minute: "Minuto",
  perHour: "Por hora",
  day: "Día",
  enterDescription: "Ingresar su descripción aquí",
  enterHere: "Ingresar aquí",
  enterMobile: "Ingresar número de móvil",
  phoneRequired: "Se requiere el número de teléfono",
  phoneValid: "El número de teléfono debe ser válido",
  unableToUpdate: "No es posible actualizar",
  membershipPlans: "Planes de Membresia",
  byWeek: "Por semana",
  byMonth: "Por mes",
  byYear: "Por año",
  custom: "Personalizado",
  name: "Nombre",
  regionState: "Región/ Estado",
  provinceState: "Provincia/ estado",
  cityTown: "Ciudad/ pueblo",
  village: "Aldea",
  membershipValidity: "Validez de la membresía",
  exportAsCSV: "Exportar como CSV",
  filterBy: "Filtrar por",
  autoCondition: "Condiciones automáticas",
  comingSoon: "Disponible en breve",
  userRole: "Puesto del usuario",
  additionalInformationRequired: "Se requiere información adicional",
  back: "Volver",
  browse: "explorar",
  clearAll: "ELIMINAR TODO",
  continue: "Continuar",
  resolveNow: "Resolver ahora",
  description: "Descripción",
  selectWeek: "Seleccionar semana",
  confirm: "CONFIRMAR",
  sendNotifications: "Notificaciones enviadas",
  createNotification: "Crear notificación",
  pleaseCheckTickMark: "Por favor, marque la marca de verificación para agregar al usuario en la lista",
  clearAllFilters: "Borrar todos los filtros",
  viewNotifications: "Ver notificaciones",
  warning: "Advertencia",
  selectMonth: "Seleccionar mes",
  selectDateRange: "Seleccionar rango de fechas",
  regionDistrict: "Región/Distrito",
  address: "AddreDirecciónss",
  familyTribe: "Comunidad",
  website: "Sitio en la web",
  deactivated: "Desactivado",
  active: "Activo",
  inactive: "Inactivo",
  country: "País",
  farmer: "Granjero",
  commodity: "Mercancía",
  quantity: "Cantidad",
  unit: "Unidad",
  price: "Precio",
  save: "Guardar",
  remove: "Eliminar",
  stateIsReq: "Se requiere el estado",
  cityIsReq: "Se requiere la ciudad",
  addressIsReq: "La dirección es obligatoria",
  membershipTypeReq: "El tipo de membresía es obligatorio",
  extendedReasonReq: "El motivo de la prórroga es obligatorio",
  numberOfDaysReq: "El número de días es obligatorio",
  extendedMembershipValidity: "Validez extendida de membresía",
  set: "ESTABLECER",
  adminRole: "Funciones de administrador",
  typeMsg: "Escribe tu mensaje aquí",
  meter: "Metro",
  kiloMeter: "Kilómetro",
  mile: "Milla",
  gram: "Gramo",
  kilogram: "Kilogramo",
  pound: "Libra",
  cubicKilo: "Kilómetro Cúbico (km³)",
  cubicMeter: "Metro Cúbico (m³)",
  cubicCentimeter: "Centímetro Cúbico (cm³)",
  cubicMilimeter: "Milímetro Cúbico (mm³)",
  showingAll: "Mostrando Todo",
  emailSentSuccessfully: "Correo electrónico enviado con éxito",
  somethingWentWrong: "Algo salió mal",
  goBack: "Volver",
  step: "Paso",
  fileError: "Error de archivo",
  ProvideFileFormat: "Nota importante: Proporcione el siguiente formato (PNG/JPEG)",
  signHere: "Firma aquí",
  all: "Todos",
  read: "Leer",
  unread: "No leído",
  markAllAsRead: "Marcar todo como leído",
  youAreUpToDate: "Estás actualizado",
  viewAllNotifications: "Ver todas las notificaciones",
  createNotificationForGroup: "Crear notificación para el grupo/varios usuarios", 
  createNotificationForDimitra: "Crear notificación para el administrador de Dimitra", 
  numOfDaysRemaining: "Número de días restantes",
  requesterNameIsRequired: "Se requiere el nombre del solicitante",
  messageIsRequired: "Se requiere el mensaje",
  emailIsInvalid: "El correo electrónico no es válido",
  emailIsRequired: "Se requiere el correo electrónico",
  filesSucessfullyUploaded: "Archivos cargados con éxito",


  loadingData: "Cargando datos...",
  markAsRead: "Marcar como leído",

  of: "de",
  ok: "Vale",

  orderBy: "Ordenar por",
  select: "Seleccionar",
  type: "Tipo",
  uploadImageVideo: "Cargar imágenes/ videos",
  user: "Usuarios",
  userName: "Nombre de usuario",
  usersSelected: "Usuario seleccionado",
  topics: "Temas",
  date: "Fecha",
  addNew: "Añadir nuevo",
  exportAsCsv: "Exportar como CSV",
  noData: "No se ha encontrado ningún dato",


  cropsReport: "Informe de Cultivos",
  today: "Hoy",
  week: "Semana",
  month: "Mes",
  year: "Año",
  cropsStatistics: "Estadísticas de Cultivos",
  crops: "Cultivos",
  acres: "Acres",
  totalPlantedArea: "Área Total Plantada",
  farmersChart: "Gráfico de Agricultores",
  cropsName: "Nombre de los Cultivos",
  farmers: "Agricultores",
  farms: "Fincas",
  planted: "Plantado",
  plantedArea: "Área Plantada",
  harvested: "Cosechado",
  yieldAcre: "Rendimiento por Acre",
  selectCrop: "Seleccionar Cultivo",
  listByYield: "Listar por Rendimiento",
  listByPlantedArea: "Listar por Área Plantada",
  equipmentReport: "Informe de Equipos",
  equipmentChart: "Gráfico de Equipos",
  selectFarmer: "Seleccionar Agricultor",
  equipmentName: "Nombre del Equipo",
  region: "Región",
  counts: "Conteos",
  large: "Grande",
  medium: "Mediano",
  small: "Pequeño",
  listByFarmer: "Listar por Agricultor",
  rowsPerPage: "Filas por Página",
  farmersReport: "Informe de Agricultores",
  farmsReport: "Informe de fincas",
  farmersStatistics: "Estadísticas de Agricultores",
  farmStatistics: "Estadísticas agrícolas",
  averageFarmerLand: "Promedio de Tierra por Agricultor",
  totalFarmerLand: "Tierra Total de Agricultor",
  largeFarmers: "Agricultores Grandes",
  mediumFarmers: "Agricultores Medianos",
  smallFarmers: "Agricultores Pequeños",
  listByLand: "Listar por Terreno",
  listByFarm: "Listar por Finca",
  AvgLandAcre: "Promedio de Tierra por Acre",
  listbyCrop: "Listar por Cultivo",
  listbyZone: "Listar por Zona",
  farmName: "Nombre de la Finca",
  zones: "Zonas",
  area: "Área",
  goalsAchievedReport: "Informe de Metas Logradas",
  listByCrops: "Listar por Cultivos",
  goalsAchievedChart: "Gráfico de Metas Logradas",
  goalsAchieved: "Metas Logradas",
  goalsFailed: "Metas No Logradas",
  successRate: "Tasa de Éxito",
  achieved: "Logrado",
  equipment: "Equipos",
  pests: "Plagas",
  regions: "Regiones",
  filterByCrops: "Filtrar por Cultivos",
  searchCrops: "Buscar Cultivos",
  batchCode: "Código de Lote",
  batchRating: "Calificación de Lote",
  MakeASelection: "Hacer una Selección",
  typeTotalCoffeeQuantity: "Ingrese la Cantidad Total de Café",
  typeHumidity: "Ingrese la Humedad",
  valueInPercent: "Valor en Porcentaje",
  purchaseOrderRequired: "Se Requiere Orden de Compra",
  totalCoffeeCherryRequired: "Se Requiere Cantidad Total de Cereza de Café",
  processTypeRequired: "Se Requiere Tipo de Proceso",
  stationInfo: "Información de la Estación",
  purchaseOrders: "Órdenes de Compra",
  processingBatch: "Lote de Procesamiento",
  processedCoffeeOutRequired: "Se Requiere Café Procesado",
  lotNo: "Número de Lote",
  addNewS: "Agregar Nuevo",
  viewAll: "Ver Todo",
  parchmentOut: "Pergamino Salido",
  processingDone: "Procesamiento Completado",
  farmerLotID: "ID del Agricultor y Lote",
  weight: "Peso",
  plantationSettings: "Configuración de Plantación",
  PlantationsEachFarmerCanCreate:
    "Número de Plantaciones que Cada Agricultor Puede Crear",
  manageAdditionalPlantationRequests:
    "Gestionar Solicitudes de Plantación Adicionales",
  autoApprove: "Aprobación Automática",
  adminApprovalRequired: "Se Requiere Aprobación del Administrador",
  close: "Cerrar",
  new_user: "Nuevo Usuario",
  KGAcre: "KG/Acre",
  pending: "Pendiente",

  //dashboard report
  "Farmer Name": "Nombre del Agricultor",
  "Goals Achieved": "Metas Logradas",
  "Goals Failed": "Metas Fallidas",
  "Success Rate": "Tasa de Éxito",

  "Equipment Name": "Nombre del Equipo",
  Region: "Región",
  Farmer: "Agricultor",
  Counts: "Recuentos",

  "Pest Name": "Nombre de la Plaga",
  "Total Area": "Área Total",
  Crop: "Cultivo",

  "Crop Name": "Nombre del Cultivo",
  Farmers: "Agricultores",
  Farms: "Fincas",
  Planted: "Sembrado",
  "Planted Area": "Área Sembrada",
  Harvested: "Cosechado",
  "Yield/acre": "Rendimiento por Acre",
  "Region Name": "Nombre de la Región",
  "Avg. Land/Acre": "Promedio de Tierra por Acre",
  Crops: "Cultivos",
  "Yield/area": "Rendimiento/área",
  "Avg. land/Acre": "Promedio de tierra/Acre",
  "Farm Name": "Nombre de la Finca",
  Zones: "Zonas",
  Area: "Área",

  "Goals Achieved Report": "Informe de Metas Logradas",
  "Farms Report": "Informe de Fincas",
  "Pest Report": "Informe de Plagas",
  "Equipment Report": "Informe de Equipos",
  "Crops Report": "Informe de Cultivos",
  "Farmers Report": "Informe de Agricultores",
  "Regional Report": "Informe Regional",
  fermentationCode: "Código de Fermentación",



  months: "Meses",
  days: "Días",
  open: "Abierto",
  closed: "Cerrado",
  moreInfoRequired: "Se Requiere Información Adicional",
  publicDueDiligenceReportSettings: "Configuración del informe público de diligencia debida",
  fieldRequired: "Este campo es obligatorio.",
  valueMustBeGreaterThanZero: "El valor debe ser mayor que cero.",
  valueExceedsLimit:
    "El tiempo de expiración no puede exceder los 12 meses según las regulaciones de EUDR.",
  valueMustBeInteger: "El valor debe ser un número entero.",
  viewDeforestationDetails:"Ver Detalles de Deforestación",

  listOfShipments:"Listado de Envios",
  viewShipment:"Ver Envío",
  shipmentCratedSuccess:"Envío creado correctamente.",
  pleaseSelectAtLeastOneDueDeligenceReport:"Por favor, seleccione al menos un informe de diligencia debida pública.",
  notifications: "Notificaciones",


  noUploadToBlockchain: "No se subió a Blockchain",
  noDataForBlockchain: "Dado que no se generaron informes de deforestación para los lugares de producción, no había datos para escribir en blockchain. Si esto fue inesperado, asegúrese de que los informes para las granjas se generaron correctamente en los pasos anteriores.",
  pleaseAgreeToDeclaration: "Por favor, acepte la declaración para concluir.",
  importProductionPlaceTT: "Permite a los usuarios importar datos del lugar de producción utilizando opciones de carga o descarga de archivos.",
  defaultCircularGeofence: "Las granjas sin una geovalla o sin información sobre su tamaño se les asignará una geovalla circular predeterminada de 4 hectáreas. Si el tamaño promedio de la granja es menor de 4 hectáreas, cambie el tamaño predeterminado haciendo clic en el botón 'Editar' a continuación.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "Según EUDR, las granjas con menos de 4 hectáreas no requieren un polígono.",
  uploadOneDeforestationAssessmentForAllFarms: "SUBIR UNA EVALUACIÓN DE DEFORESTACIÓN PARA TODAS LAS GRANJAS",
  uploadAssessment: "Subir Evaluación",


  "timeAgo": {
    "minute": "hace un minuto",
    "minutes": "hace {count} minutos",
    "hour": "hace una hora",
    "hours": "hace {count} horas",
    "day": "hace un día",
    "days": "hace {count} días",
    "month": "hace un mes",
    "months": "hace {count} meses",
    "year": "hace un año",
    "years": "hace {count} años"
  },

  confirmDialog: {
    assessmentBuilder: {
      delete: {
        title: "Eliminar Evaluación",
        message: "¿Estás seguro de que deseas eliminar la Evaluación?",
        confirmBtn: "¿Confirmar?"
      }
    },
    dueDiligenceReport: {
      delete: {
        title: "Eliminar Informe de Diligencia Debida EUDR",
        message: "¿Estás seguro de que deseas eliminar el Informe de Diligencia Debida EUDR?",
        confirmBtn: "Confirmar"
      }
    },
    farm: {
      delete: {
        title: "Eliminar Finca",
        message: "¿Estás seguro de que deseas eliminar la Finca?",
        confirmBtn: "Confirmar"
      }
    },
    status: {
      delete: {
        title: "Eliminar Estado de Deforestación",
        message: "¿Estás seguro de que quieres eliminar el estado de deforestación?",
        confirmBtn: "Confirmar",
      },
    },
  },

  tickets: {
    actions: {
      create: "Crear ticket",
      delete: "eliminar ticket",
      edit: "editar ticket",
    },
    areaOfRequest: "Área de solicitud",
    assignee: "Asignatario",
    deleteTicket: {
      confirmation: "¿Seguro que desea eliminar el ticket {0}?",
    },
    dueDate: "Fecha límite",
    filters: {
      ticketFor: "ticket para",
    },
    form: {
      ticketType: {
        admin: "Crear ticket para Admin Dimitra",
        user: "Crear ticket para el usuario de la aplicación",
      },
    },
    markAsRead: "Marcar como leído",
    messages: {
      created: {
        success: "Se ha creado el ticket correctamente",
      },
      deleted: {
        success: "Se ha eliminado el ticket correctamente",
      },
    },
    noData: "¡No se ha encontrado ningún ticket!",
    noDataHelpText: `Todavía no tiene ningún ticket asignado.{0}{1}Haga clic en el botón "Crear Ticket" en la parte superior de esta pantalla para empezar.`,
    pickerInMenu: "Selector en el menú",
    priority: {
      high: "Alto",
      label: "Prioridad",
    },
    reply: "Contestar",
    requestedDateTime: "Fecha y hora solicitadas",
    requestorDetails: "Detalles del solicitante",
    requestorEmail: "Correo electrónico solicitante",
    subject: "tema",
    ticketsForItems: {
      all: "Todos",
      dimitraAdmin: "Admin Dimitra",
      multipleUsers: "Usuarios múltiples",
      singleUser: "Usuario único",
    },
    title: "Tickets",
  },

  faqSection: {
    createFaq: "CREAR PREGUNTA FRECUENTE",
    createTopic: "Crear tema",
    selectTopic: "Seleccionar tema",
    faqQuestion: "Pregunta más frecuente",
    faqAnswer: "Respuesta de la pregunta frecuente",
    uploadImgVid: "Cargar imagen/ video",
    disInFaq: "Enseñar en la sección de preguntas frecuentes",
    editFaq: "Editar preguntas frecuentes",
    topicName: "Nombre del tema",
    parentTopic: "Tema principal",
    editTopic: "Editar tema",
    createSection: "Primero cree una sección",
    createTopicFirst: "Primero cree un tema",
    questionReq: "La pregunta de la FAQ es obligatoria",
    answerReq: "La respuesta de la FAQ es obligatoria",
  },
  seeDetails: "Ver detalles",
  clickHere: "Hacer clic aquí",
  tutorials: {
    howtoCreateanAdminUser: "Cómo crear un usuario administrador",
    howToCreateanActivationKey: "Cómo crear una clave de activación",
    individualandBulkFarmCreation: "Creación individual y masiva de fincas",
    creatingaDueDiligenceStatement: "Creación de una declaración de debida diligencia",
    title: "Tutoriales y Guías",
    noTutorials: "No hay tutoriales",
    addTutorialPrompt: "Por favor, agregue primero un tutorial o guía.",
    videoNotAvailable: "Video no disponible en su idioma preferido.",
    watchVideo: "Ver video",
    viewTutorial: "Ver tutorial",
    // Kenyan tutorials
    creatingAndManagingUsers: "Creación y gestión de usuarios",
    howToCreateActivationKeys: "Cómo crear claves de activación",
    userRolesAndPermissions: "Roles y permisos de usuario",
    creatingAFarm: "Creación de una finca",
    creatingADueDiligenceStatement: "Creación de una declaración de debida diligencia",
    sharingStatementWithOperator: "Compartir declaración con operador",
    riskMitigation: "Mitigación de riesgos",
    generalSettings: "Configuración general",
    assessmentBuilder: "Constructor de evaluaciones",
    bulkUserUpload: "Carga masiva de usuarios",
    // Admin management
    manageTutorials: "Gestionar Tutoriales",
    createTutorial: "Crear Tutorial",
    editTutorial: "Editar Tutorial",
    deleteTutorial: "Eliminar Tutorial",
    deleteConfirmation: "¿Está seguro de que desea eliminar el tutorial '{title}'?",
    createSuccess: "Tutorial creado exitosamente",
    updateSuccess: "Tutorial actualizado exitosamente",
    deleteSuccess: "Tutorial eliminado exitosamente",
    createError: "Error al crear tutorial",
    updateError: "Error al actualizar tutorial",
    deleteError: "Error al eliminar tutorial",
    saveError: "Error al guardar tutorial",
    loadError: "Error al cargar tutoriales",
    createFirstTutorial: "Cree su primer tutorial para comenzar",
    // Form fields
    description: "Descripción",
    url: "URL",
    urlType: "Tipo de Contenido",
    displayOrder: "Orden de Visualización",
    organization: "Organización",
    organizationHint: "Seleccione 'Global' para tutoriales disponibles para todas las organizaciones, o elija una organización específica",
    userType: "Tipo de Usuario",
    userTypeHint: "Seleccione qué tipo de usuarios puede ver este tutorial",
    isActive: "Está Activo",
    status: "Estado",
    actions: "Acciones",
    // Status options
    active: "Activo",
    inactive: "Inactivo",
    global: "Global",
    // User types
    appUsers: "Usuarios de App",
    adminUsers: "Usuarios Admin",
    // Validation messages
    titleRequired: "El título es requerido",
    titleMinLength: "El título debe tener al menos 3 caracteres",
    urlRequired: "La URL es requerida para enlaces externos",
    urlInvalid: "Por favor, ingrese una URL válida",
    urlTypeRequired: "El tipo de contenido es requerido",
    fileRequired: "El archivo es requerido para tutoriales basados en archivos",
    urlOrFileRequired: "Se debe proporcionar URL o archivo",
    // Search functionality
    searchOrganizations: "Buscar organizaciones...",
    noOrganizationsFound: "No se encontraron organizaciones",
    searchTutorials: "Buscar tutoriales...",
    selectOrganization: "Seleccionar organización...",
    excludeGlobalForOrg: "Excluir tutoriales globales para la organización seleccionada",
    exclusionUpdateSuccess: "Configuración de tutoriales de la organización actualizada",
    exclusionUpdateError: "Error al actualizar configuración de tutoriales de la organización",
    exclusionStatusLoadError: "Error al cargar configuración de tutoriales de la organización",
  },

  helpDesk: "Mesa de ayuda",
  generateSecretKey: "Generar Clave Secreta",
  secretKey: "Clave Secreta",
  secretKeyCopied: "Clave secreta copiada al portapapeles",
  copied: "Copiado",
  copySecretKeyHint: "Haga clic en el icono de copia para copiar la clave secreta",
}